module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/angle-down-a69eafc8109d4b16658df2fcd0ccd8f9.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/angle-down.svg
// module id = IwJh
// module chunks = 24